export const REQUEST_BASICS = {
    baseURL: process.env.NODE_ENV === 'development' ? ""  : "https://teach.jy0838.cn",
    maxContentLength: 2000,
    timeout: 20000,
    // 发送请求时头部信息
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
         'X-Requested-With':   'XMLHttpRequest'
    },
}